<fieldset class="bordas">
    <div fxLayout="row" fxLayoutGap="20px" fxFlexFill>
        <mat-form-field fxFlex="50%" fxLayoutGap="20px" fxFlexOffset="20px">
            <mat-label>Proveniente de:</mat-label>
            <mat-select [(ngModel)]="beneficio.beneficioSocial.id" 
                        name="beneficioSocial_{{pinBeneficioSocial}}"
                        (selectionChange)="carregarDadosBenficioSocial()"
                        required>
                <mat-option></mat-option>
                <mat-option *ngFor="let i of beneficiosSociais" [value]=i.id>
                    {{i.descricao}}
                </mat-option>
            </mat-select>
            <mat-hint *ngIf="!beneficiosSociais || beneficiosSociais?.length === 0" align="start">Nenhum benefício social cadastrado
            </mat-hint>
        </mat-form-field>


        <mat-form-field fxFlex="30%">
            <input currencyMask 
                   name="valor_{{pinValor}}"
                   [(ngModel)]="beneficio.valor" 
                   placeholder="Valor:"
                   matInput 
                   maxlength="13"
                   (blur)="calcularValorRenda()"
                   [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
            <span matPrefix>R$&nbsp;</span>
        </mat-form-field>
        
        <div id="excluir" class="excluir">
            <button mat-icon-button *ngIf="perfilAcesso.deleta" 
                (click)="deletar()"
                style="padding: 0px;">
                <mat-icon>delete_forever</mat-icon>
            </button>   
        </div>
    </div>

</fieldset>